import {LineItemTransitions} from "./lineItemTransitions";

/**
 * What a cancellation reason records on the return line item when it is used to take an article out
 * of the return flow.
 *
 * Mirrors App\Enum\Return\ReturnRequestLineItemTransition in MP-API. The same line item transition
 * covers three very different business outcomes — a refused return, an exchange, a return cancelled
 * at the customer's request — and only the reason tells them apart, so it is configured here rather
 * than derived.
 */
export const ReturnLineItemOutcomes = {
    REJECT: 'reject',
    MISSING: 'missing',
    CANCEL: 'cancel',
};

/**
 * The outcome only has a meaning for the transitions that take an article back out of a return.
 * Anywhere else there is no return line item to record anything on.
 */
export function transitionCarriesReturnOutcome(transition) {
    return [
        LineItemTransitions.CANCEL_RETURNING_RUNNER,
        LineItemTransitions.CANCEL_RETURNING_RETAILER,
    ].includes(transition);
}

export function getReturnLineItemOutcomes() {
    return [
        ReturnLineItemOutcomes.REJECT,
        ReturnLineItemOutcomes.MISSING,
        ReturnLineItemOutcomes.CANCEL,
    ];
}
